import { http } from '@/api/http'
import { unwrapSingle } from '@/api/normalizers'
import { unwrapList } from '@/api/normalizers'
import type { StationTicket } from '@/lib/pos-types'
import { normalizeStationTicket } from '@/api/normalizers'

export const stationTicketsApi = {
  markReady: async (ticketId: string): Promise<{ orderId: string }> => {
    const res = await http.post<unknown>(`/stations/tickets/${encodeURIComponent(ticketId)}/ready`, {})
    const data = unwrapSingle(res.data) as { order?: { id?: string } }
    return { orderId: String(data?.order?.id ?? '') }
  },
  reprint: async (ticketId: string): Promise<{ printed: boolean }> => {
    const res = await http.post<unknown>(`/stations/tickets/${encodeURIComponent(ticketId)}/reprint`, {})
    const data = unwrapSingle(res.data) as { printed?: boolean }
    return { printed: Boolean(data?.printed) }
  },
  list: async (params?: { station?: string; orderId?: string; status?: string; printStatus?: string; limit?: number }): Promise<StationTicket[]> => {
    const qs = new URLSearchParams()
    if (params?.station) qs.set('station', params.station)
    if (params?.orderId) qs.set('orderId', params.orderId)
    if (params?.status) qs.set('status', params.status)
    if (params?.printStatus) qs.set('print_status', params.printStatus)
    if (params?.limit) qs.set('limit', String(params.limit))
    const res = await http.get<unknown>(`/stations/tickets${qs.toString() ? `?${qs.toString()}` : ''}`)
    return unwrapList(res.data).map(normalizeStationTicket)
  },
}
